// "While you wait" quotes (BuildWaiting). Only quotes with a checkable primary source; commonly misattributed
// ones (e.g. "Tell me and I forget…", not Franklin's) stay out. tr = translation, except Atatürk (original).
// es falls back to en. Owner-approved list; keep author + source on every entry (waitQuotes test).
export const WAIT_QUOTES = [
  {
    author: { en: "Nelson Mandela", tr: "Nelson Mandela" },
    source: {
      en: "Launch of the Mindset Network, Johannesburg, 16 July 2003",
      tr: "Mindset Network açılışı, Johannesburg, 16 Temmuz 2003",
    },
    text: {
      en: "Education is the most powerful weapon which you can use to change the world.",
      tr: "Eğitim, dünyayı değiştirmek için kullanabileceğiniz en güçlü silahtır.",
    },
  },
  {
    author: { en: "John F. Kennedy", tr: "John F. Kennedy" },
    source: {
      en: "Remarks prepared for the Dallas Trade Mart, 22 November 1963",
      tr: "Dallas Trade Mart için hazırlanan konuşma, 22 Kasım 1963",
    },
    text: {
      en: "Leadership and learning are indispensable to each other.",
      tr: "Liderlik ve öğrenme birbiri için vazgeçilmezdir.",
    },
  },
  {
    author: { en: "Winston Churchill", tr: "Winston Churchill" },
    source: {
      en: "House of Commons, 4 November 1952",
      tr: "Avam Kamarası, 4 Kasım 1952",
    },
    text: {
      en: "Personally I am always ready to learn, although I do not always like being taught.",
      tr: "Ben şahsen her zaman öğrenmeye hazırım, ama bana ders verilmesinden her zaman hoşlanmam.",
    },
  },
  {
    author: { en: "Mustafa Kemal Atatürk", tr: "Mustafa Kemal Atatürk" },
    source: {
      en: "Speech to teachers, Samsun, 22 September 1924",
      tr: "Samsun'da öğretmenlere konuşma, 22 Eylül 1924",
    },
    text: {
      en: "For everything in the world — for civilisation, for life, for success — the truest guide is knowledge and science.",
      tr: "Dünyada her şey için, medeniyet için, hayat için, muvaffakiyet için en hakiki mürşit ilimdir, fendir.",
    },
  },
  {
    author: { en: "Confucius", tr: "Konfüçyüs" },
    source: {
      en: "Analects 2.15, tr. James Legge",
      tr: "Konuşmalar (Analektler) 2.15",
    },
    text: {
      en: "Learning without thought is labour lost; thought without learning is perilous.",
      tr: "Düşünmeden öğrenmek boşa emektir; öğrenmeden düşünmek tehlikelidir.",
    },
  },
  {
    author: { en: "Seneca", tr: "Seneca" },
    source: {
      en: "Letters to Lucilius, 7.8",
      tr: "Lucilius'a Mektuplar, 7.8",
    },
    text: {
      en: "Men learn while they teach.",
      tr: "İnsanlar öğretirken öğrenir.",
    },
  },
  {
    author: { en: "Abigail Adams", tr: "Abigail Adams" },
    source: {
      en: "Letter to John Quincy Adams, 8 May 1780",
      tr: "John Quincy Adams'a mektup, 8 Mayıs 1780",
    },
    text: {
      en: "Learning is not attained by chance, it must be sought for with ardor and attended to with diligence.",
      tr: "Öğrenmek tesadüfen elde edilmez; tutkuyla aranmalı ve özenle sürdürülmelidir.",
    },
  },
  {
    author: { en: "Dr. Seuss", tr: "Dr. Seuss" },
    source: {
      en: "I Can Read With My Eyes Shut! (1978)",
      tr: "I Can Read With My Eyes Shut! (1978)",
    },
    text: {
      en: "The more that you read, the more things you will know. The more that you learn, the more places you'll go.",
      tr: "Ne kadar çok okursan o kadar çok şey bilirsin. Ne kadar çok öğrenirsen o kadar çok yere gidersin.",
    },
  },
];
